import React, { Component } from 'react'

const withData = ({
  data = [],
  fetch = () => console.log('no fetch function'),
  fetching = false,
}) => WrappedComponent => {
  return class extends Component {
    render() {
      return <WrappedComponent {...{ data, fetch, fetching }} {...this.props} />
    }
  }
}

export default withData
